import { Button } from '@mui/material';
import React from 'react';
import { BUTTON_VARIANTS, SIZES } from '../../constants/constants';
import I18n from '../../i18n/I18n';
import { Icons } from '../../icons/Icons';

type ManageButtonProps = {
    token: string;
    disabled: boolean;
    isMobile: boolean;
};

export function ManageButton({ token, disabled, isMobile }: ManageButtonProps) {
    return (
        <Button
            size={SIZES.small}
            variant={BUTTON_VARIANTS.outlined}
            disabled={disabled}
            sx={{
                fontSize: '12px',
                px: 1,
                alignSelf: isMobile ? 'flex-start' : 'auto'
            }}
            endIcon={<Icons.ArrowDropDownOutlined sx={{ fontSize: 16 }} />}
        >
            <I18n token={token} />
        </Button>
    );
}

